"use client";

import Button, { ButtonType } from "@/app/(components)/generics/Button/Button";
import IconArrowRight from "@/app/(components)/generics/Icons/IconArrowRight";
import IconBell from "@/app/(components)/generics/Icons/IconBell";
import IconCheck from "@/app/(components)/generics/Icons/IconCheck";
import IconStar from "@/app/(components)/generics/Icons/IconStar";
import { ModalStore } from "@/app/stores/ModalStore";
import { useT } from "@/app/translations/useT";
import { DefaultProps } from "@/app/types/common/DefaultProps";
import { ToolPhaseType, ToolsKeys } from "@/app/types/home/HomeTools";
import { URLs } from "@/app/utils/URLs";
import homeStyles from "../../Home.module.css";
import { buildToolGroups, TOOL_GROUP_CSS_CLASS } from "./Tools.logic";
import styles from "./Tools.module.css";

type Props = DefaultProps & {
  keys: ToolsKeys;
  phases: ToolPhaseType[];
};

export default function Tools(props: Props) {
  const T = useT();
  const _lang = props.params.lang;

  const { keys, phases } = props;

  const supTitle = T(keys.supTitle);
  const title = T(keys.title);
  const introText = T(keys.introText);

  return (
    <div className={styles.container}>
      <div className={styles.intro}>
        {(supTitle || title) && (
          <div className={styles.introTitles}>
            {supTitle && <h3 className={styles.introSupTitle}>{supTitle}</h3>}
            {title && <h2 className={styles.introTitle}>{title}</h2>}
          </div>
        )}

        <div className={styles.checks}>
          {keys.checks.map((check) => (
            <div className={styles.checkItem} key={check.title}>
              <IconCheck />
              <div className={styles.checkContent}>
                <h3 className={styles.checkTitle}>{T(check.title)}</h3>
                <p className={styles.checkText}>{T(check.text)}</p>
              </div>
            </div>
          ))}
        </div>

        {introText && <p className={styles.introText}>{introText}</p>}
      </div>

      {buildToolGroups(phases, keys).map((group) => (
        <div key={group.id} className={styles.toolsGroup}>
          {group.label && (
            <h3
              className={`${homeStyles.supTitle} ${styles.groupLabel} ${styles[TOOL_GROUP_CSS_CLASS[group.id]]}`}
            >
              {T(group.label)}
            </h3>
          )}

          <div className={styles.toolsGrid}>
            {group.tools.map((tool) => (
              <div key={tool.id} className={styles.toolCard}>
                <span className={styles.toolNumber}>{tool.id}</span>
                <div className={styles.toolHeader}>
                  <div className={styles.toolIcon}>{tool.icon}</div>
                </div>
                <h3 className={styles.toolTitle}>
                  {tool.highlighted && (
                    <span className={styles.toolStar} role="img" aria-label={T(keys.flagship)}>
                      <IconStar size={20} filled={true} />
                    </span>
                  )}
                  {T(tool.title)}
                </h3>
                <p className={styles.toolDesc}>{T(tool.desc)}</p>
                <div className={styles.toolAction}>
                  {tool.available ? (
                    <Button
                      text={T(keys.btnAccess)}
                      type={ButtonType.PRIMARY}
                      href={URLs.pathOf(tool.href)}
                      min={true}
                      afterIcon={<IconArrowRight size={20} />}
                      ariaLabel={`${T(keys.btnAccess)} : ${T(tool.title)}`}
                    />
                  ) : (
                    <Button
                      text={T(keys.btnNotify)}
                      type={ButtonType.OUTLINE}
                      isLink={false}
                      min={true}
                      beforeIcon={<IconBell size={18} />}
                      onClick={() => ModalStore.getState().openSignUp(props.params)}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
